import api from "./apiService";

// Get Dashboard Summary
export const GetDashboard = async (LabID, year) => {
  try {
    const response = await api.get('/Home/Dashboard', {
      params: { Labid: LabID, Year: year },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Monthly Lab Data (by date range)
export const Monthly_Lab_Data = async (data) => {
  try {
    const response = await api.get('/Home/Monthly_Lab_Data', {
      params: {
        Labid: data.LabID,
        StartDate: data.StartDate,
        EndDate: data.EndDate,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Monthly & Daily Report
export const MonthlyDailyReport = async (LabID, YEAR) => {
  try {
    const response = await api.get('/Home/GetDashboardMOnthlyDaily', {
      params: {
        LabiD: LabID,
        YEAR: YEAR,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Pending Tests
export const getpendingtest = async (LabID) => {
  try {
    const response = await api.get('/Home/GetPendingTest', {
      params: {
        LabiD: LabID,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Orders (Order Management)
export const getOrders = async (LabID, StartDate, EndDate, SearchTerm, PageNumber = 1, PageSize = 10) => {
  try {
    const response = await api.get('/Home/GetOrders', {
      params: {
        LabID: LabID,
        StartDate: StartDate || undefined,
        EndDate: EndDate || undefined,
        SearchTerm: SearchTerm || undefined,
        PageNumber: PageNumber,
        PageSize: PageSize,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
